import AddEntryAlert from './AddEntryAlert';

export default AddEntryAlert;
